import { render, staticRenderFns } from "./lookTarinTea.vue?vue&type=template&id=04afa929"
import script from "./lookTarinTea.vue?vue&type=script&lang=js"
export * from "./lookTarinTea.vue?vue&type=script&lang=js"
import style0 from "./lookTarinTea.vue?vue&type=style&index=0&id=04afa929&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports